// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2OLiY","content":"GlobalSearch_content__pWRkR"};